export const BRAND_NAME = "Groundwork Academy";
export const BRAND_TAGLINE = "Build strength from the ground up.";
export const ACCENT_COLOR = "#17A78F";
